import script from "./ScannedItemsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ScannedItemsList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__